import * as React from 'react';
import { extractProperty } from '../../../../../utilities/customStyles';

const Rings = ({
  pie, data, theme, back, border
}) => {
  return (
    <g>
      {pie.map((ring, idx) => {
        const dataObj = data[idx];
        const { color } = dataObj;
        const ringColor = color || theme.RingColors[idx];
        let stroke = 'white';
        let extractedValue = ringColor;
        if (back && !border) {
          extractedValue = extractProperty(dataObj.triskeleClass.unfilled, 'background');
        } else if (back && border) {
          const innerColorValue = extractProperty(dataObj.triskeleClass.unfilled, 'border');
          if (innerColorValue) {
            const getColorValue = innerColorValue.match(/(?<=#)(.*?)$/);
            if (getColorValue && getColorValue.length > 0 && getColorValue[0]) {
              extractedValue = `#${getColorValue[0]}`;
            }
          }
        } else if (!back && border) {
          const innerColorValue = extractProperty(dataObj.triskeleClass.filled, 'border');
          if (innerColorValue) {
            const getColorValue = innerColorValue.match(/(?<=#)(.*?)$/);
            if (getColorValue && getColorValue.length > 0 && getColorValue[0]) {
              extractedValue = `#${getColorValue[0]}`;
            }
          }
        } else if (!back && !border) {
          extractedValue = extractProperty(dataObj.triskeleClass.filled, 'background');
        }

        if (extractedValue) {
          stroke = extractedValue;
        } else {
          stroke = ringColor;
        }
        // check decimals between 0 and 1
        if (!(dataObj.value >= 0 && dataObj.value <= 1)) {
          return null;
        }
      
        return (
          <path
            className={`${!back ? 'active-rings' : 'inactive-rings'} ${(!border) ? ' stroke-width-no-border' : ' stroke-width-with-border'}`}
            key={`r_${idx}`}
            strokeLinecap="round"
            strokeLinejoin="round"
            d={ring.curves[0].sector.path.print()}
            stroke={stroke}
          />
        );
      })}
    </g>
  );
};


export default Rings;
